module.exports = __webpack_public_path__ + "media/home/DigitalStorage-4434b8eb.png";